import React from 'react'
import SearchContainer from 'modules/react/search/SearchContainer'
import SearchContent from 'modules/react/search/SearchContent'

export default function Search (props) {
return (
    <SearchContainer {...props}>
      <SearchContent/>
    </SearchContainer>
  )
}